import axiosInstance from "../services/axiosInstance";

export const feedbackAPI = {
  async submitFeedback(requestBody) {
    const response = await axiosInstance.post("/api/feedback", requestBody);
    return response.data;
  },
};

export default feedbackAPI;
